<template>
    <div class="footer-component">
        <v-container fluid class="pa-0">
            <v-row>
                <v-col cols="12" lg="4">
                    <footer-info/>
                </v-col>
                <v-col cols="12" lg="4">
                    <footer-navigation/>
                </v-col>
                <v-col cols="12" lg="4">
                    <footer-social-networks/>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>

import FooterInfo from '@/components/footer/FooterInfo.vue';
import FooterNavigation from '@/components/footer/FooterNavigation.vue';
import FooterSocialNetworks from '@/components/footer/FooterSocialNetworks.vue'

export default{
    name: 'FooterComponent',
    components: {
        FooterInfo,
        FooterNavigation,
        FooterSocialNetworks
    }
}

</script>
